// Shared cn() utility for @lamtix/ui components.
// Mirror of apps/tenant-dashboard/src/lib/utils.ts.
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
